import { create } from 'zustand';
import {emptyGetBaechaListParams, GetBaechaListParams} from "../containers/BaechaList2/BaechaList2.interface";
import Constants from "../constants";
import {fetchBaechaDataAPI2} from "../api/baechaAPI";

interface BaechaList2State {
	filter: GetBaechaListParams;
	page: number;
	pageSize: number;
	data: any[];
	loading: boolean;

	setFilter: (filter: GetBaechaListParams) => void;
	setPage: (page: number) => void;
	setPageSize: (size: number) => void;

	fetch: () => Promise<void>;
	reset: () => void;
}

export const useBaechaList2Store = create<BaechaList2State>((set, get) => ({
	filter: emptyGetBaechaListParams,
	page: 1,
	pageSize: Constants.PAGE_SIZE,
	data: [],
	loading: false,

	setFilter: (filter) => {
		set({ filter, page: 1 });
		get().fetch();
	},

	setPage: (page) => {
		set({ page });
		get().fetch();
	},

	setPageSize: (pageSize) => {
		set({ pageSize, page: 1 });
		get().fetch();
	},

	fetch: async () => {
		const { filter, page, pageSize } = get();

		set({ loading: true });

		try {
			const res = await fetchBaechaDataAPI2({
				...filter,
				offset: (page - 1) * pageSize,
				limit: pageSize,
			});

			set({ data: res });
		} catch (e) {
			console.error(e);
		} finally {
			set({ loading: false });
		}
	},

	reset: () => {
		set({
			filter: emptyGetBaechaListParams,
			page: 1,
			pageSize: Constants.PAGE_SIZE,
			data: [],
		});
		get().fetch();
	},
}));